import QuoteHeaderLogo from './QuoteHeaderLogo'
export default QuoteHeaderLogo
export * from './QuoteHeaderLogo'
